const routes = [
  {
    path: '/',
    component: 'pages/Home',
  },
  {
    path: '/neighbourhood',
    component: 'pages/Neighbourhood',
  },
  {
    path: '/register',
    component: 'pages/Register/Register',
  },
  {
    path: '/building',
    component: 'pages/Building',
  },
  {
    path: '/views',
    component: 'pages/Views/Views',
  },
  {
    path: '/team',
    component: 'pages/Team',
  },
  {
    path: '/interiors',
    component: 'pages/Interiors',
  },
  {
    path: '/legacy',
    component: 'pages/Legacy',
  },
  {
    path: '/floorplans',
    component: 'pages/Floorplans/Floorplans',
  },
  {
    path: '/thankyou',
    component: 'pages/ThankYou',
  },
  {
    path: '/virtualtours',
    component: 'pages/VirtualTours/VirtualTours',
  },
];

module.exports = routes;



// WEBPACK FOOTER //
// ./src/routes.js